import { frontPageConstants }   from './FrontPageConstants';
import * as frontPageInterfaces from './FrontPageInterfaces';

export {
    frontPageConstants,
    frontPageInterfaces,
};